import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Redirect, Route, Switch, useLocation, useRouteMatch, } from 'react-router-dom';
import { makePath } from 'shared';
import { OneTimePayment, AutopayAuth } from './views';
function Routes() {
    const { path } = useRouteMatch();
    const location = useLocation();
    return (_jsxs(Switch, { children: [_jsx(Route, { exact: true, path: makePath(path, '/one-time-payment'), children: _jsx(OneTimePayment, {}) }), _jsx(Route, { exact: true, path: makePath(path, '/'), children: _jsx(AutopayAuth, {}) }), _jsx(Route, { path: "*", children: _jsx(Redirect, { to: { pathname: makePath(path, '/'), search: location.search } }) })] }));
}
export default Routes;
